import _ from 'lodash'
import moment from 'moment'
import { addEightHour } from '@/util'
import * as directSalesApi from '@/api/directSales'

const cancelBtn = { text: '取消预约', type: 'plain', size: 'small', class: ['radius'], id: 'cancel' }
export const updateContactsBtn = {
  text: '修改',
  fn: 'updateContacts',
  btnId: '1',
  dialogConfig: {
    // content: '确定修改联系人信息？',
    confirmButtonText: '确认修改',
    cancelButtonText: '暂不修改'
  },
  param: { handleId: 'updateContacts' }
}
export const deleteContactsBtn = {
  text: '删除',
  fn: 'deleteContacts',
  btnId: '2',
  dialogConfig: {
    content: '是否确认删除联系人？',
    confirmButtonText: '确认删除',
    cancelButtonText: '暂不删除'
  },
  param: { handleId: 'deleteContacts' }
}
export const addContactsBtn = {
  text: '新增联系人',
  type: 'active',
  size: 'large',
  fn: 'addContacts',
  btnId: '3',
  id: 'add',
  dialogConfig: {
    confirmButtonText: '确认新增',
    cancelButtonText: '取消'
  },
  param: { handleId: 'addContacts' }
}
export const changeContactsBtn = {
  text: '修改状态',
  fn: 'changeContacts',
  btnId: '4',
  dialogConfig: {
    content: '是否确认修改默认状态？',
    confirmButtonText: '确认修改',
    cancelButtonText: '取消'
  },
  param: { handleId: 'changeContacts' }
}

export const btnCallBack = async (v, param) => {
  if (v.type == 'disabled') {
    return false
  }
  if (v.fn && typeof directSalesApi[v.fn] === 'function') {
    return await directSalesApi[v.fn](param)
  }
}

export const getStatusName = data => {
  let index = data?.statusFlag
  const shopCouponStatusFlags = new Map([
    [-1, '已取消'],
    [0, '已创建'],
    [1, '待生效'],
    [2, '已生效'],
    [3, '已过期'],
    [5, '已使用'],
    [6, '待激活'],
    [7, '退款中'],
    [8, '已退款'],
    [9, '已退款'], //LPO-12565 服务合约已退货的订单和卡券显示为已退款
    [10, '已冻结'],
    [11, '使用中'],
    [12, '待审批'], //已核销待审批
    [13, '待审批'] //退货待审批
  ])

  let res = shopCouponStatusFlags.get(index) || ''
  // if (data?.couponType === 3 && [8, 9].includes(index)) {
  //   // 2: 保养套餐 3:礼包
  //   res = '已失效'
  // }
  if ([2, 3].includes(data?.couponType) && data?.lockStatusFlag === 1) {
    res = '使用中'
  }
  return res
}

export const getActiveTime = data => {
  // console.log('getActiveTime--', data)
  let res = []
  let start = (data?.activeStartTime && addEightHour(data?.activeStartTime.slice(0))) || ''
  let end = (data?.activeEndTime && addEightHour(data?.activeEndTime.slice(0))) || ''
  start && res.push(start)
  end && res.push(end)
  let str = ''
  if (start && end) {
    str = res.join(' 至 ')
  } else if (start) {
    str = `从 ${start} 起`
  } else {
    str = ''
    if (data?.statusFlag === 6) {
      // 待激活状态卡券得生效时间若为空显示“激活后生效"
      str = '激活后生效'
    }
  }
  return { str, start, end }
}

export const getActiveaMonth = datas => {
  return datas?.activeMonth === -1 ? '不限制' : `${datas?.activeMonth || ''}个月`
}

export const getModActiveaMonth = datas => {
  let activeMonth = getActiveaMonth(datas)
  let exceedMileEnd = datas?.exceedMileEnd == -1 ? '不限制' : datas?.exceedMileEnd ? `${datas?.exceedMileEnd}公里（二者以先到者为准）` : ''
  return `${activeMonth}/${exceedMileEnd}`
}
